import 'babel-polyfill'
import Vue from 'vue'
import App from './App.vue'
import store from './store'
import VueGtag from 'vue-gtag'
import VueScrollTo from 'vue-scrollto'

import '@/assets/scss/_webfont.scss'
import '@/assets/scss/_mixin.scss'
import '@/assets/scss/_variable.scss'
import '@/assets/scss/_reset.scss'
import '@/assets/scss/_common.scss'
import router from './router'

Vue.config.productionTip = false
Vue.use(VueScrollTo)
Vue.use(VueGtag, {
  config: { id: 'UA-160419788-1' }
})

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')
